
import { Vue, Component } from "vue-property-decorator";
import { mdiAlertOctagonOutline } from "@mdi/js";

@Component
export default class NotFound extends Vue {
  icon = mdiAlertOctagonOutline;
}
